import React, { useContext, useEffect, useRef, useState } from "react";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import { ReactComponent as SEARCHICON } from "../../assets/icons/search.svg";
import { ReactComponent as ADDMEMBER } from "../../assets/icons/addMember.svg";
import { ReactComponent as SORT } from "../../assets/icons/sort.svg";
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import { ReactComponent as REVOKE } from "../../assets/icons/revoke-icon.svg";
import { ReactComponent as REMOVEMEMBER } from "../../assets/icons/remove-member.svg";
import { ReactComponent as REVOKEADMIN } from "../../assets/icons/revoke-admin.svg";
import { ReactComponent as GRANTADMIN } from "../../assets/icons/admin-v2.svg";
import { ReactComponent as Copy } from "../../assets/icons/copy.svg";
import { NotificationContext } from "../../Context/NotificationContext";
import { DataContext } from "../../Context/DataContext";
import { TransitionContext } from "../../Context/TransitionContext";
import { getQueryParam, useScreenTransition } from "../../Hooks/useScreenTransition";
import axios from "axios";
import AddMemberPopUp from "./TeamMember/AddMemberPopUp";
import "./TeamMembers.css";
import PopUpModal from "../../NewComponents/PopUpModal";
import Timer from "../../NewComponents/Timer";
import NoData from "../../NewComponents/NoData";
import { AccountStatus, AccountType } from "../../utility/enums";
import { auth, firestore, getFullHttpUrl } from "../../firebase.config";
import { v4 as uuidv4 } from "uuid";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";
import NewButton from "../../NewComponents/NewButton";
import { AuthContext } from "../../Context/AuthContext";
import { useLocation } from "react-router-dom";


const TeamMembers = ({ windowSize }) => {
  const { showNotification } = useContext(NotificationContext);
  const { userData, teamData } = useContext(DataContext);
  const { setColor } = useContext(TransitionContext);
  const [selectedSort, setSelectedSort] = useState("teamJoinTimestamp");
  const { transitionTo } = useScreenTransition();
  const [showAddMember, setShowAddMember] = useState(false);
  const [selectedMember, setSelectedMember] = useState("");
  const [selectedModal, setSelectedModal] = useState("");
  const [revokeInviteBtn, setRevokeInviteBtn] = useState("Revoke Invite");
  const [revokeAdminBtn, setRevokeAdminBtn] = useState("Revoke Admin Access");
  const [removeMemberBtn, setRemoveMemberBtn] = useState("Remove Member");
  const [makeAdminBtn, setMakeAdminBtn] = useState("Make an Admin");
  const [leaveTeamBtn, setLeaveTeamBtn] = useState("Leave Team");
  const [showDetailModal, setShowDetailModal] = useState("");
  const [users, setUsers] = useState([]);
  const [invitedUsers, setInvitedUsers] = useState([]);
  const [loadedUsers, setLoadedUsers] = useState(false);
  const [nameSearch, setNameSearch] = useState("");
  const [moreOptions, setMoreOptions] = useState(false);
  const [lastInvites, setLastInvites] = useState([]);
  const [resendInviteBtn, setResendInviteBtn] = useState("Resend Invite");
  const { clearSignOut } = useContext(AuthContext);
  
  const action= getQueryParam("action");
  const [showAlreadyJoinedPopUp, setShowAlreadyJoinedPopUp] = useState(action ? action === "already-joined" : false);
  const [showAlreadyMemberPopUp, setShowAlreadyMemberPopUp] = useState(action ? action === "already-member" : false);
  
  let firstLoad = useRef();
  let firstTeamLoad = useRef();
  if (!firstLoad.current) firstLoad.current = true;
  if (!firstTeamLoad.current) firstTeamLoad.current = true;

  let nextTeamPointer = useRef();
  if (!nextTeamPointer.current) nextTeamPointer.current = null;

  useEffect(() => {
    if (!(userData && userData.teamId)) {
      transitionTo("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  useEffect(() => {
    const invites = JSON.parse(localStorage.getItem("lastTeamInvite"));
    setLastInvites(invites || []);
  }, []);

    const getUserOrders = async (email) => {
      
      const ordersTotal = await firestore
        .collection("orders")
        .where("email", "==", email)
        .get()
        .then((oSnap) => {
          return oSnap.empty ? 0 : oSnap.docs.length;
        });
  
        return ordersTotal;
    };

  useEffect(() => {
    if (userData && userData.teamId) {
      setLoadedUsers(false);

      const unsubscribe = firestore.collection("users").where("teamId", "==", userData.teamId).onSnapshot(
          async(querySnapshot) => {
            if(querySnapshot.empty){
              return;
            }

            const users = await Promise.all(
              querySnapshot.docs.map(async (userDoc) => {
                const ordersTotal = await Promise.resolve(getUserOrders(userDoc.data().email));
                return { id: userDoc.id, ordersTotal: ordersTotal, ...userDoc.data() };
              })
            );
            setUsers(users);

            setLoadedUsers(true);
          },
          (error) => {
            // console.log(error);
              showNotification(
                "Error",
                "There was an error loading the users. Please, reload the page.",
                "error"
              );
            setLoadedUsers(true);
          }
        );

      return () => unsubscribe();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  useEffect(() => {
    if (userData && userData.teamId) {
      setLoadedUsers(false);

      let query = firestore.collection("teamInvites");
      const unsubscribe = query
        .where("teamId", "==", userData.teamId)
        .onSnapshot(
          (querySnapshot) => {
            setInvitedUsers(
                querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            );
            setLoadedUsers(true);
          },
          (error) => {
            console.log(error);
            showNotification(
              "Error",
              "There was an error loading the users. Please, reload the page.",
              "error"
            );
            setLoadedUsers(true);
          }
        );

      return () => unsubscribe();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const handleResendInvite = (user) => {
    setResendInviteBtn("Resending...");
    setMoreOptions("");

    axios({
      method: "post",
      url: getFullHttpUrl("team-resendMemberInvitation"),
      data: {
        teamData: teamData,
        id: user.id,
        email: user.email,
        name: user.name,
        teamRole: user.teamRole,
      },
    })
      .then(async (res) => {
        const newInvite = lastInvites
          .filter((i) => i.id !== user.id)
          .concat({ id: user.id, time: new Date().getTime() });
        setLastInvites(newInvite);

        localStorage.setItem("lastTeamInvite", JSON.stringify(newInvite));
        setResendInviteBtn("Resend Invite");
        setMoreOptions("");
        showNotification(
          "Success",
          "User is invited to the team, invitation email sent to user email.",
          "success"
        );
      })
      .catch((e) => {
        // console.log(e);
        setResendInviteBtn("Resend Invite");
        setMoreOptions("");
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
      });
  };

  const handleRevokeInvite = (user) => {
    setRevokeInviteBtn("Revoking...");
    axios({
      method: "post",
      url: getFullHttpUrl("team-revokeInvite"),
      data: {
        teamData: teamData,
        id: user.id,
        email: user.email,
      },
    })
      .then(async (res) => {
        handleModalClose();
        setRevokeInviteBtn("Revoke Invite");
        showNotification(
          "Success",
          "User is revoked from joining the team.",
          "success"
        );
      })
      .catch((e) => {
        console.log(e);
        setRevokeInviteBtn("Revoke Invite");
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
      });
  };

  const handleRemoveMember = async (user) => {

    setRemoveMemberBtn("Removing...");
    setLeaveTeamBtn("Leaving...");


    try{
      const invoiceSnap = await firestore.collection("orderInvoices").where("userID", "==", user.id).where("status", "==", "pay-later").get();
      if(!invoiceSnap.empty) {
        showNotification("Error", "Pending Invoice Payments. Please, pay the invoices before leaving or removing the member.", "error");
        return false;
      }
      // const orderSnap = await firestore.collection("orders").where("userID", "==", user.id).where("paypalOrderID", "==", "pay-later").where("status", "!=", "cancelled").get();
      // if(!orderSnap.empty) {
      //   showNotification("Error", "Pending Orders Payments. Please, pay the orders before leaving or removing the member.", "error");
      //   return false;
      // }
      if(userData.teamRole === "owner" && user.id === userData.id){
        showNotification("Error", "Owner cannot remove himself from the team. Please, remove all members before leaving the team or ask support to change ownership.", "error");
        return false;
      }

    await axios({
      method: "post",
      url: getFullHttpUrl("team-removeMember"),
      data: {
        id: user.id,
        email: user.email
      },
    })
      .then(async (res) => {
        handleModalClose();
        setRemoveMemberBtn("Remove Member");
        setLeaveTeamBtn("Leave Team");
        showNotification("Success", "Member removed from the team.", "success");
      })
      .catch((e) => {
        setRemoveMemberBtn("Remove Member");
        setLeaveTeamBtn("Leave Team");
        console.log(e);
        showNotification(
          "Error",
          "There was an error removing member. Please, try again or refresh the page.",
          "error"
        );
      });

    }catch(e){
      console.log(e);
      showNotification(
          "Error",
          "There was an error removing member. Please, try again or refresh the page.",
          "error"
        );
        return;
    }finally{
      setRemoveMemberBtn("Remove Member");
      setLeaveTeamBtn("Leave Team");
    }
  };

  const handleMakeAdmin = async(user) => {
    setMakeAdminBtn("Making...");

    await firestore.collection("users").doc(user.id).update({
      teamRole: "admin"
    }).then(() => {
        handleModalClose();
        setMakeAdminBtn("Make an Admin");

        showNotification(
          "Success",
          "User has given admin access for this team.",
          "success"
        );
      })
      .catch((e) => {
        setMakeAdminBtn("Make an Admin");
        console.log(e);
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
      });
  };

  const handleRevokeAdminAccess = async(user) => {
    setRevokeAdminBtn("Revoking...");
    await firestore.collection("users").doc(user.id).update({
      teamRole: "member"
    }).then(() => {
        handleModalClose();
        setRevokeAdminBtn("Revoke Admin Access");
        showNotification(
          "Success",
          "Team admin access revoked from the user.",
          "success"
        );
      })
      .catch((e) => {
        setRevokeAdminBtn("Revoke Admin Access");
        // console.log(e);
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
      });
  };

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    return splitted[1] + " " + splitted[2] + ", " + splitted[3];
  };

  const handleModalClose = () => {
    setSelectedModal("");
    setSelectedMember("");
    setMoreOptions("");
  };

  const sortData = (data) => {
    const sortedData = data.sort((a,b) => {
      if( selectedSort === "ordersTotal"){
        return b[selectedSort] - a[selectedSort];
      }
      if(selectedSort === "teamJoinTimestamp" ){
        return a[selectedSort] - b[selectedSort];
      }

      return a[selectedSort].toLowerCase() > b[selectedSort].toLowerCase() ? 1 : -1;
    });

    return sortedData;
  }

  const capitalize = (value) => {
    if (value.length > 1) {
      const array = value.split(" ");
      const capitalizeWordArray = array.map((data) => {
        if (data.length > 1) {
          return (
            data.slice(0, 1).toUpperCase() + data.slice(1, -1) + data.slice(-1)
          );
        }
        return data.toUpperCase();
      });
      return capitalizeWordArray.join(" ");
    } else {
      return value.toUpperCase();
    }
  };


  const handleCopyTeamJoinLink = () => {
    const link = window.location.host;
    const teamName = teamData.name.replace(/ /g, "-").toLowerCase();
    navigator.clipboard.writeText(`${link}?join-team=${teamName}&token=${teamData.id}&create-account=true&redirect=false`);
    showNotification("Success", "Team join link copied to clipboard.", "success");
  }

  const handleSignOut = () => {
    auth.signOut();
    setShowAlreadyJoinedPopUp(false);
    clearSignOut();
  };

  const handleAlreadyMember = () => {
    transitionTo(`/account/team-members`);
    setShowAlreadyMemberPopUp(false);
    setShowAlreadyJoinedPopUp(false);
  };

  return (
    <>
    {showAlreadyJoinedPopUp && 
      <PopUpModal
        title={"Already Joined"}
        subText={teamData ? teamData.name : ""}
        text={"You are already part of a team and you can't join another one. Please sign out or leave the team to join the team."}
        btnText={"Sign out"}
        onClose={handleAlreadyMember}
        onClick={handleSignOut}
        showClose
        backBtnText={"Leave Team"}
        onBackClick={() => {
          transitionTo(`/account/team-members`);
        }}
      >
        <REMOVEMEMBER />
      </PopUpModal>
      
      }
    {showAlreadyMemberPopUp && 
      <PopUpModal
        title={"Team Joined"}
        subText={teamData ? teamData.name : ""}
        text={"You've successfully joined the team. You can now start using the team's features."}
        btnText={"OK"}
        onClose={handleAlreadyMember}
        onClick={handleAlreadyMember}
        showClose
      >
        <GRANTADMIN />
      </PopUpModal>
      
      }
      {selectedMember && selectedModal === "revoke-invite" && (
        <PopUpModal
          title={"Revoke Invite"}
          backBtnText="Cancel"
          subText="Are you sure you want to revoke the invite for this user?"
          text={selectedMember.name}
          btnText={revokeInviteBtn}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={() => handleModalClose()}
          onClick={() => {
            handleRevokeInvite(selectedMember);
          }}
          onBackClick={() => handleModalClose()}
          disableBtn={revokeInviteBtn === "Revoking..."}
        >
          <REVOKE />
        </PopUpModal>
      )}
      {selectedMember && selectedModal === "remove-member" && (
        <PopUpModal
          title={"Remove Member"}
          backBtnText="Cancel"
          subText="Are you sure you want to remove this member?"
          text={selectedMember.name}
          warningText={"All orders, quotes, invoices related to this member will be removed too."}
          btnText={removeMemberBtn}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={() => handleModalClose()}
          onClick={() => {
            handleRemoveMember(selectedMember);
          }}
          onBackClick={() => handleModalClose()}
          disableBtn={removeMemberBtn === "Removing..."}
        >
          <REMOVEMEMBER />
        </PopUpModal>
      )}
      {selectedMember && selectedModal === "leave-team" && (
        <PopUpModal
          title={"Leave team"}
          backBtnText="Cancel"
          subText="Are you sure you want to leave the team?"
          text={selectedMember.name}
          btnText={leaveTeamBtn}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={() => handleModalClose()}
          onClick={() => {
            handleRemoveMember(selectedMember);
          }}
          onBackClick={() => handleModalClose()}
          disableBtn={leaveTeamBtn === "Leaving..."}
        >
          <REMOVEMEMBER />
        </PopUpModal>
      )}
      {selectedMember && selectedModal === "revoke-admin" && (
        <PopUpModal
          title={"Revoke Admin Access"}
          backBtnText="Cancel"
          subText="Are you sure you want to revoke admin access for this user?"
          text={selectedMember.name}
          btnText={revokeAdminBtn}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={() => handleModalClose()}
          onClick={() => {
            handleRevokeAdminAccess(selectedMember);
          }}
          onBackClick={() => handleModalClose()}
          disableBtn={revokeAdminBtn === "Revoking..."}
        >
          <REVOKEADMIN />
        </PopUpModal>
      )}
      {selectedMember && selectedModal === "make-admin" && (
        <PopUpModal
          title={"Make an Admin"}
          backBtnText="Cancel"
          subText="Are you sure you want to make this member an admin?"
          text={selectedMember.name}
          btnText={makeAdminBtn}
          iconBgColor="##E6FAF2"
          showClose
          onClose={() => handleModalClose()}
          onClick={() => {
            handleMakeAdmin(selectedMember);
          }}
          onBackClick={() => handleModalClose()}
          disableBtn={makeAdminBtn === "Making..."}
        >
          <GRANTADMIN />
        </PopUpModal>
      )}

      {showAddMember && (
        <AddMemberPopUp
          setShowAddMember={setShowAddMember}
          showAddMember={showAddMember}
          copyLink={handleCopyTeamJoinLink}
        />
      )}
      <AccountNavBar
        windowSize={windowSize}
        selectedTab="team-members"
        accountMainPadding={false}
      >
       

        <div className="accountMainTitleRow lg:flex-row flex-col w-full px-5 pt-5">
          <h2 className="accountMainTitle">Team Members</h2>

          <div className="flex items-center sm:flex-row flex-col md:gap-4 gap-2 lg:w-2/3 w-full justify-end">
            <div className="flex items-center lg:w-full md:w-2/3 w-full relative ">
              <input
                className="accountDetailsSearchInput w-full"
                placeholder="Search by Name"
                vlaue={nameSearch}
                onChange={(e) => setNameSearch(e.target.value)}
              />
              <SEARCHICON className="absolute right-4" />
            </div>

            <button
              className="accountDetailsAddBtn xl:w-1/4 md:w-1/2 sm:w-1/3 w-full"
              onClick={() => {
                handleCopyTeamJoinLink()
              }}
            >
              <Copy width={20} height={20} className="[&_path]:stroke-[#000]" />
              <p className="accountDetailsAddBtnText">Copy link</p>
            </button>

            {userData && userData.teamRole !== "member" && (
              <button
                className="accountDetailsAddBtn xl:w-1/4 md:w-1/2 sm:w-1/3 w-full"
                onClick={() => {
                  setShowAddMember(true);
                  handleModalClose();
                }}
              >
                <ADDMEMBER className="accountDetailsAddBtnIcon" />
                <p className="accountDetailsAddBtnText">Add Member</p>
              </button>
            )}
          </div>
        </div>

        {loadedUsers && users.concat(invitedUsers).length > 0 ? (
          <div className="accountDetailsScroll accountDetailsFullScroll md:w-[calc(100vw-270px)] w-full">
            <table className="accountDetailsTable">
              <thead>
                <tr>
                  <th>
                    <p className="accountDetailsHeading">№</p>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Name</p>
                      {selectedSort === "name" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("name")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("name")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Email</p>
                      {selectedSort === "email" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("email")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("email")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Join date</p>
                      {selectedSort === "teamJoinTimestamp" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("teamJoinTimestamp")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("teamJoinTimestamp")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Role</p>
                      {selectedSort === "teamRole" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("teamRole")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("teamRole")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Orders</p>
                      {selectedSort === "ordersTotal" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("ordersTotal")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("ordersTotal")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Status</p>
                      {selectedSort === "teamStatus" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("teamStatus")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("teamStatus")}
                        />
                      )}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortData(users.concat(invitedUsers)
                  .filter(
                    (u) =>
                      u?.name?.includes(nameSearch.toLowerCase()) ||
                      u?.name?.includes(capitalize(nameSearch))
                  ))
                  .map((user, i) => (
                    <tr key={user.id}>
                      <td>
                        <p className="accountDetailsText">{i + 1}</p>
                      </td>
                      <td>
                        {user.name.length > 15 &&
                          showDetailModal === user.id + user.name && (
                            <div className="accountdetailHoverBox">
                              <p
                                className="accountDetailsText captialLetters"
                              >
                                {user.name}
                              </p>
                            </div>
                          )}
                        <p
                          className="accountDetailsText captialLetters"
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                            setShowDetailModal(user.id + user.name)
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        >
                          {user.name}
                        </p>
                      </td>
                      <td>
                        <p className="accountDetailsText">{user.email}</p>
                      </td>
                      <td>
                        <p className="accountDetailsText captialLetters">
                          {user.teamJoinTimestamp
                            ? formatDate(user.teamJoinTimestamp)
                            : "-"}
                        </p>
                      </td>
                      <td>
                        <p className="accountDetailsText captialLetters">
                          {user.teamRole || "-"}
                        </p>
                      </td>
                      <td>
                        <p className="accountDetailsText">
                          {user.ordersTotal || "-"}
                        </p>
                      </td>
                      <td>
                        <p
                          className="accountDetailsText accountDetailsStatus"
                          style={{
                            backgroundColor:
                              user.teamStatus === "invited"
                                ? "#FFDDCF"
                                : "#C1F4C3",
                          }}
                        >
                          {user.teamStatus || AccountStatus.ACTIVE}
                        </p>
                      </td>
                      <td>
                        {
                        userData.id === user.id ? (
                          <div
                            className="hardCopyAddressIconWrap"
                          >
                            {moreOptions === user.id ? (
                              <MORESELECTED
                                className="hardCopyAddressIcon"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevents event bubbling
                                  setMoreOptions("");
                                }}
                              />
                            ) : (
                              <MORE
                                className="hardCopyAddressIcon"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevents event bubbling
                                  setMoreOptions(user.id);
                                }}
                              />
                            )}
                            {moreOptions === user.id && (
                              <div className="hardCopyAddressEditWrap">
                                {
                                  <div
                                    className="hardCopyAddressEdit"
                                    onClick={() => {
                                      setSelectedModal("leave-team");
                                      setSelectedMember(user);
                                    }}
                                  >
                                    Leave Team
                                  </div>
                                }
                              </div>
                            )}
                          </div> ) :
                        userData.teamRole === AccountType.MEMBER && user.teamStatus === "invited" && user.userInvited === userData.id  ? (
                          <div
                            className="hardCopyAddressIconWrap"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevents event bubbling
                              setMoreOptions((prev) =>
                                prev === user.id ? "" : user.id
                              );
                            }}
                            tabIndex={0} // Enables blur event for accessibility
                            onBlur={() => setMoreOptions("")}
                          >
                            {moreOptions === user.id ? (
                              <MORESELECTED
                                className="hardCopyAddressIcon"
                              />
                            ) : (
                              <MORE
                                className="hardCopyAddressIcon"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevents event bubbling
                                  setMoreOptions((prev) =>
                                    prev === user.id ? "" : user.id
                                  );
                                }}
                              />
                            )}
                            {moreOptions === user.id && (
                                <div className="hardCopyAddressEditWrap">
                                  <Timer
                                    user={user}
                                    lastInvites={lastInvites}
                                    title={resendInviteBtn}
                                    onClick={() => {
                                      handleResendInvite(user);
                                    }}
                                  />
                                  <div
                                    className="hardCopyAddressEdit"
                                    onClick={() => {
                                      setSelectedModal("revoke-invite");
                                      setSelectedMember(user);
                                    }}
                                  >
                                    Revoke Invite
                                  </div>
                                </div>
                            )}
                          </div>
                        ) : userData.teamRole === AccountType.OWNER ||
                          userData.teamRole === "admin" ? (
                          <div
                            className="hardCopyAddressIconWrap"
                          >
                            {
                              (moreOptions === user.id ? (
                                <MORESELECTED
                                  className="hardCopyAddressIcon"
                                  onClick={(e) => {e.stopPropagation(); setMoreOptions("")}}
                                />
                              ) : (
                                <MORE
                                  className="hardCopyAddressIcon"
                                  onClick={(e) => {e.stopPropagation(); setMoreOptions(user.id)}}
                                />
                              ))}
                            {moreOptions === user.id &&
                              user.teamStatus === "invited" && (
                                <div className="hardCopyAddressEditWrap">
                                  <Timer
                                    user={user}
                                    lastInvites={lastInvites}
                                    title={resendInviteBtn}
                                    onClick={() => {
                                      handleResendInvite(user);
                                    }}
                                  />
                                  <div
                                    className="hardCopyAddressEdit"
                                    onClick={() => {
                                      setSelectedModal("revoke-invite");
                                      setSelectedMember(user);
                                    }}
                                  >
                                    Revoke Invite
                                  </div>
                                </div>
                              )}
                            {moreOptions === user.id &&
                                user.teamStatus ===
                                "active" && (
                                <div className="hardCopyAddressEditWrap">
                                  {
                                    user.teamRole ===
                                    AccountType.ADMIN  &&
                                    <div
                                      className="hardCopyAddressEdit"
                                      onClick={() => {
                                        setSelectedModal("revoke-admin");
                                        setSelectedMember(user);
                                      }}
                                    >
                                      Revoke Admin Access
                                    </div>
                                  }
                                  {
                                    user.teamRole ===
                                    AccountType.MEMBER &&
                                    <div
                                      className="hardCopyAddressEdit"
                                      onClick={() => {
                                        setSelectedModal("make-admin");
                                        setSelectedMember(user);
                                      }}
                                    >
                                      Make an Admin
                                    </div>
                                  }
                                  <div
                                    className="hardCopyAddressEdit"
                                    onClick={() => {
                                      setSelectedModal("remove-member");
                                      setSelectedMember(user);
                                    }}
                                  >
                                    Remove Member
                                  </div>
                                </div>
                              )}
                          </div>
                        ) : null}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        ) : loadedUsers ? (
          <NoData
            title="You Don't Have Any Team Member"
            text="Create/Join Team member"
            showBtn={false}
            btnText="Create/Join Team"
            onClick={(e) => transitionTo(`/`, e)}
          />
        ) : (
          <NoData
            type="order"
            showBtn={false}
            loading={true}
            loadingText={"members"}
          />
        )}
      </AccountNavBar>
    </>
  );
};

export default TeamMembers;
